import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { first } from 'rxjs';

export const authorValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const firstName = control.get('firstName');
  const lastName = control.get('lastName');
  const bio = control.get('bio');

  var isValid = false

  if (firstName != null && firstName.value != "" && lastName != null && lastName.value != "" && bio != null && bio.value != "")  {
    isValid = true
  } else {
    isValid = false
  }

  return isValid ? null : { valid: true };
};

